// extracted by mini-css-extract-plugin
export default {"trancheRow":"tranches_trancheRow__bnEjj","fixedInputs":"tranches_fixedInputs__ifqDF","trancheLabel":"tranches_trancheLabel__JriiH","chargeSection":"tranches_chargeSection__0541G"};